import React, { PureComponent } from 'react';
import * as echarts from 'echarts';

class IndustryPieCharts extends PureComponent {
  constructor(props) {
    super(props);
    this.chartRefs = {
      business: React.createRef(),
      transportation: React.createRef(),
      public: React.createRef()
    };
    this.screenHeight = window.screen.height;
    this.textFontSize = '13.5';
    this.seriesCenter = ['40%', '60%'];
    if(this.screenHeight < 900){
      this.textFontSize = '9';
      this.seriesCenter = ['40%', '45%'];
    }
  }

  componentDidMount() {
    this.initCharts();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      this.updateCharts();
    }
  }

  initCharts() {
    const { data } = this.props;
    const { business, transportation, public: publicSector } = this.chartRefs;

    const businessChart = echarts.init(business.current);
    businessChart.setOption(this.getPieOption(data.business, '经营行业（(81%)', 70));//6425台
    const businessOption = this.getPieOption(data.business, '经营行业(81%)', 70);//6425台
    businessOption.series[0].center = this.seriesCenter; // 向上移动
    businessChart.setOption(businessOption);

    const transportationChart = echarts.init(transportation.current);
    transportationChart.setOption(this.getPieOption(data.transportation, '交通出行（16%)', 50));//1276台

    const publicChart = echarts.init(publicSector.current);
    publicChart.setOption(this.getPieOption(data.public, '事业单位(3%)', 50));//235台

    window.addEventListener('resize', () => {
      businessChart.resize();
      transportationChart.resize();
      publicChart.resize();
    });
  }

  updateCharts() {
    const { data } = this.props;
    const { business, transportation, public: publicSector } = this.chartRefs;

    const businessOption = this.getPieOption(data.business, '经营行业(81%)', 70);//6425台
    businessOption.series[0].center = this.seriesCenter; // 保持位置调整
    echarts.init(business.current).setOption(businessOption);
    echarts.init(transportation.current).setOption(this.getPieOption(data.transportation, '交通出行(16%)', 60));//1276台
    echarts.init(publicSector.current).setOption(this.getPieOption(data.public, '事业单位(3%)', 50));//235台
  }

  getPieOption(data, title, radius) {
    
    return {
      title: {
        text: title,
        left: 'center',
        top: '3%',
        textStyle: {
          color: '#fff',
          fontSize: 11
        }
      },
      tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b}: {c} ({d}%)',
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        textStyle: {
          color: '#fff'
        }
      },
      legend: {
        type: 'plain', // 普通图例，不使用滚动模式
        orient: 'horizontal', // 横向排列
        left: 'center', // 水平居中
        top: '8%', // 调整垂直位置，给标题留出空间
        textStyle: {
          color: '#fff',
          fontSize: this.textFontSize
        },
        itemWidth: 10,
        itemHeight: 10,
        // 控制图例换行，超出容器宽度自动换行
        // 可根据实际情况调整容器宽度相关逻辑，这里简单设置为自适应
        // 也可以通过计算数据长度等方式动态设置 width
        width: '100%',
        overflow: 'break'
      },
      series: [
        {
          name: title,
          type: 'pie',
          radius: [`${radius - 20}%`, `${radius}%`],
          center: this.seriesCenter,
          data: data,
          label: {
            show: false
          },
          itemStyle: {
            borderRadius: 4,
            borderColor: '#1E293B',
            borderWidth: 2
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      ]
    };
  }

  render() {
    return (
      <div className="pie-charts-container" style={{ display: 'flex', gap: '20px', width: '100%' }}>
        <div ref={this.chartRefs.business} style={{ width: '40%', height: '400px',marginTop: '-10px' }} />
        <div ref={this.chartRefs.transportation} style={{ width: '35%', height: '400px',marginTop: '-10px' }} />
        <div ref={this.chartRefs.public} style={{ width: '25%', height: '400px',marginTop: '-10px' }} />
      </div>
    );
  }
}

export default IndustryPieCharts;
